import React from "react";
import ReactPlayer from "react-player/lazy";

const VideoPlayer = ({ link, ...rest }) => {
	return <ReactPlayer url={link} {...rest} />;
};

export default VideoPlayer;
